/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleServicePriceApiRequest } from '../../models/hotel-edit-single-service-price-api-request';

export interface ApiHotelManageEditSingleServicePricePost$Params {
      body: HotelEditSingleServicePriceApiRequest
}

export function apiHotelManageEditSingleServicePricePost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleServicePricePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleServicePricePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleServicePricePost.PATH = '/api/hotel/manage/edit/single/service-price';
